import { useNavigate } from "react-router-dom";
import { Flame, ChevronLeft } from "lucide-react";

function LegalShell({ title, children }) {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-background">
      <header className="flex items-center justify-between px-5 md:px-10 py-4 border-b border-border">
        <div className="flex items-center gap-2 cursor-pointer" onClick={() => nav("/")}>
          <Flame className="text-primary" size={22} strokeWidth={2.5} />
          <span className="font-display text-xl">ROX<span className="text-primary">LAB</span></span>
        </div>
        <button data-testid="legal-back-btn" onClick={() => nav(-1)} className="flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground">
          <ChevronLeft size={16} /> Retour
        </button>
      </header>
      <main className="max-w-2xl mx-auto px-5 py-10">
        <h1 className="font-display text-3xl sm:text-4xl mb-8">{title}</h1>
        <div className="space-y-6 text-sm text-muted-foreground leading-relaxed [&_h2]:text-foreground [&_h2]:font-display [&_h2]:text-xl [&_h2]:mb-2 [&_h2]:mt-6 [&_b]:text-foreground [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1">
          {children}
        </div>
        <p className="text-xs text-muted-foreground mt-12">Dernière mise à jour : juin 2026.</p>
      </main>
    </div>
  );
}

export default function Privacy() {
  return (
    <LegalShell title="Politique de confidentialité">
      <section data-testid="privacy-content">
        <p>Roxlab accorde une grande importance à la protection de vos données personnelles, en particulier vos <b>données de santé et de performance</b>. Cette politique explique quelles données nous collectons, pourquoi, et quels sont vos droits (conformément au RGPD).</p>

        <h2>Données collectées</h2>
        <ul>
          <li><b>Compte :</b> nom, adresse email, mot de passe (chiffré).</li>
          <li><b>Profil physiologique :</b> taille, poids, âge, niveau, records, disponibilités, sommeil.</li>
          <li><b>Données de santé :</b> blessures et antécédents déclarés, ressenti d'effort (RPE), empêchements signalés.</li>
          <li><b>Nutrition :</b> régime, restrictions, supplémentation déclarés.</li>
          <li><b>Utilisation :</b> séances loggées, progression, données d'abonnement.</li>
        </ul>

        <h2>Finalités</h2>
        <p>Ces données servent exclusivement à générer et personnaliser votre programme d'entraînement HYROX, assurer le suivi par votre coach, et gérer votre abonnement. Vos données de santé ne sont utilisées que pour adapter les recommandations sportives.</p>

        <h2>Base légale & consentement</h2>
        <p>Le traitement de vos données de santé repose sur votre <b>consentement explicite</b>, donné lors de l'onboarding. Vous pouvez le retirer à tout moment en supprimant votre compte.</p>

        <h2>Partage</h2>
        <p>Vos données ne sont jamais vendues. Elles sont partagées uniquement avec : votre coach assigné, notre prestataire de paiement (Stripe) pour la facturation, notre prestataire d'emails transactionnels, et le moteur d'IA utilisé pour générer votre programme.</p>

        <h2>Durée de conservation</h2>
        <p>Vos données sont conservées tant que votre compte est actif. Elles sont supprimées sur demande ou après une période d'inactivité prolongée.</p>

        <h2>Vos droits</h2>
        <p>Vous disposez d'un droit d'accès, de rectification, d'effacement, de portabilité et d'opposition. Pour exercer ces droits, contactez-nous via l'adresse de support de l'application.</p>

        <h2>Sécurité</h2>
        <p>Les mots de passe sont chiffrés (bcrypt), les échanges sont sécurisés (HTTPS), et l'accès aux données est restreint.</p>
      </section>
    </LegalShell>
  );
}
